import About from "./modules/About/Page/About";
import ContactUs from "./modules/ContactUs/Page/ContactUs";
import Home from "./modules/Home/Page/Home";
import Cloud from "./modules/KeyFeatures/Cloud/Page/Cloud";
import PrivacyPolicy from "./modules/PrivacyPolicy/Page/PrivacyPolicy";
import Product from "./modules/Product/Page/Product";
import ProductDetails from "./modules/ProductDetails/Page/ProductDetails";
import ReleaseNote from "./modules/ReleaseNote/Page/ReleaseNote";
import E3TakeOver from "./modules/KeyFeatures/E3TakeOver/Page/E3TakeOver";
import Lockset from "./modules/KeyFeatures/Lockset/Page/Lockset";
import MobileLink from "./modules/KeyFeatures/MobileLink/Page/MobileLink";
import Nvr from "./modules/KeyFeatures/Nvr/Page/Nvr";
import SmartReport from "./modules/KeyFeatures/SmartReport/Page/SmartReport";
import VideoRecording from "./modules/KeyFeatures/VideoRecording/Page/VideoRecording";
import VideoTagging from "./modules/KeyFeatures/VideoTagging/Page/VideoTagging";
import WarrantyPolicy from "./modules/WarrantyPolicy/Page/WarrantyPolicy";
import KeyAttribute from "./modules/KeyFeatures/KeyAttribute/Page/KeyAttribute";
import RequestDemoPage from "./modules/RequestDemo/Page/RequestDemoUser";
import Login from "./global/components/Login/Login";
import DocumentationLibrary from "./modules/DocumentationLibrary/Page/DocumentationLibrary";
import MobileCredential from "./modules/KeyFeatures/MobileCredential/Page/MobileCredential";
import Badging from "./modules/KeyFeatures/Badging/Page/Badging";
import { VideoRecordinTagging } from "./modules/KeyFeatures/VideoTagging/Components/VideoTaggingContent";
import VideoRecordinAndTagging from "./modules/KeyFeatures/VideoRecordinTagging/Page/VideoRecordinTagging";
import MobileApp from "./modules/KeyFeatures/MobileApplication/Page/MobileApp";
import Feedback from "./modules/Feedback/Page/Feedback";
import CloudPlus from "./modules/KeyFeatures/CloudPlus/Page/CloudPlus";
import TrueCloud from "./modules/KeyFeatures/TrueCloud/Page/TrueCloud";
import TuitorialLibrary from "./modules/TuitorialLibrary/Page/TuitorialLibrary";
import TenantVideo from "./modules/KeyFeatures/TenantVideo/Page/TenantVideo";
import Directory from "./modules/KeyFeatures/Directory/Page/Directory";
import MigrateNeptune from "./modules/KeyFeatures/MigrateNeptune/Page/MigrateNeptune";
import LicenseFeature from "./modules/LicenseFeature/Page/LicenseFeature";
import PartitionRoleManage from "./modules/KeyFeatures/PartitionRoleManage/Page/PartitionRoleManage";
import EventScheduleManage from "./modules/KeyFeatures/EventScheduleManage/Page/EventScheduleManage";
import ThreatLevelManage from "./modules/KeyFeatures/ThreatLevelManage/Page/ThreatLevelManage";
import BackupRestore from "./modules/KeyFeatures/BackupRestore/Page/BackupRestore";
import ServiceManage from "./modules/KeyFeatures/ServiceManage/Page/ServiceManage";
import Installer from "./modules/KeyFeatures/Installer/Page/Installer";
import Credential from "./modules/KeyFeatures/Credential/Page/Installer";
import MobilePro from "./modules/KeyFeatures/MobilePro/Page/MobilePro";

export const routes = [
  { path: "/", element: <Home /> },
  { path: "/login", element: <Login /> },
  { path: "/product", element: <Product /> },
  { path: "/product/:id", element: <ProductDetails /> },
  { path: "/company", element: <About /> },
  { path: "/user-interface", element: <KeyAttribute /> },
  { path: "/cloud", element: <Cloud /> },
  { path: "/cloud-plus", element: <CloudPlus /> },
  { path: "/true-cloud", element: <TrueCloud /> },
  { path: "/installer", element: <Installer /> },
  { path: "/credential", element: <Credential /> },
  { path: "/directory", element: <Directory /> },
  { path: "/mobile-pro", element: <MobilePro /> },

  { path: "/e3-takeover", element: <E3TakeOver /> },
  { path: "/mobile-credential", element: <MobileCredential /> },
  { path: "/mobile-link", element: <MobileLink /> },
  { path: "/video-integration", element: <Nvr /> },
  { path: "/schlage-lockset", element: <Lockset /> },
  { path: "/smart-report", element: <SmartReport /> },
  { path: "/video-recording", element: <VideoRecording /> },
  { path: "/mobile-applications", element: <MobileApp /> },
  { path: "/badging", element: <Badging /> },
  { path: "/video-recording-tagging", element: <VideoRecordinAndTagging /> },
  { path: "/tenant-video", element: <TenantVideo /> },
  { path: "/migrate-neptune", element: <MigrateNeptune /> },
  // { path: "/directory", element: <Directory /> },
  { path: "/partition-management", element: <PartitionRoleManage /> },
  { path: "/event-schedule", element: <EventScheduleManage /> },
  { path: "/threat-manage", element: <ThreatLevelManage /> },
  { path: "/backup-restore", element: <BackupRestore /> },
  { path: "/service-management", element: <ServiceManage /> },


  { path: "/warrantypolicy", element: <WarrantyPolicy /> },
  // Protected route - only accessible when logged in
  {
    path: "/documentation-library",
    element: <DocumentationLibrary />,
    protected: true,
  },
  {
    path: "/tuitorial-library",
    element: <TuitorialLibrary />,
    protected: true,
  },
  { path: "/license-feature", element: <LicenseFeature /> },
  { path: "/privacypolicy", element: <PrivacyPolicy /> },
  { path: "/releasenote", element: <ReleaseNote /> },
  { path: "/contact-us", element: <ContactUs /> },
  { path: "/feedback", element: <Feedback /> },
  { path: "/request-demo", element: <RequestDemoPage /> },

  // Legacy routes - these will be caught by LegacyRedirectHandler
  // But we can also add them here as fallback
  { path: "/features/*", element: <Product />, legacy: true },
  { path: "/subpage/*", element: <About />, legacy: true },
  { path: "/download/*", element: <KeyAttribute />, legacy: true },
  { path: "/manual/*", element: <KeyAttribute />, legacy: true },
];
